@if (activePatient) {
    <div class="logged-in-view h-full overflow-y-auto">
        <div class="w-full flex flex-col md:flex-row justify-between mb-8 gap-4">
            <div class="flex flex-col gap-4">
                <h1 class="text-app-primary-10">Patientenakte</h1>
                <h3 class="font-thin! text-app-primary-10">{{ activePatient.title }} {{ activePatient.firstName }} {{ activePatient.lastName }}</h3>
            </div>
            @if (appointmentForRecipe) {
                <div class="flex items-center">
                    <button class="btn primary-button" (click)="toRecipeCreate(appointmentForRecipe)">
                        <span>Neues Rezept ausstellen</span>
                    </button>
                </div>
            }
        </div>

        <!-- Obere Karten: Person & Neue Notiz -->
        <div class="grid grid-cols-12 gap-6 mb-8 w-full">
            <!-- Linke Karte: Person -->
            <div class="col-span-12 lg:col-span-6">
                <div class="bg-white rounded-button shadow-sm border border-app-primary-10 p-6 h-full">
                    <div class="text-app-primary-20 font-semibold border-b border-app-primary-10/10 pb-2 mb-4">
                        Person
                    </div>
                    <div class="space-y-3">
                        <div class="grid grid-cols-1 lg:grid-cols-3">
                            <span class="text-app-primary-10 text-sm">Name:</span>
                            <span class="col-span-2 font-normal text-sm lg:text-lg">{{ activePatient.title }} {{ activePatient.firstName }} {{ activePatient.lastName }}</span>
                        </div>
                        <div class="grid grid-cols-1 lg:grid-cols-3">
                            <span class="text-app-primary-10 text-sm">Geburtsdatum:</span>
                            <span class="col-span-2 font-normal text-sm lg:text-lg">{{ activePatient.dateOfBirth | date: 'dd.MM.yyyy' }}</span>
                        </div>
                        <div class="grid grid-cols-1 lg:grid-cols-3">
                            <span class="text-app-primary-10 text-sm">Adresse:</span>
                            <div class="col-span-2 flex flex-col font-normal text-sm lg:text-lg">
                                <span>{{ activePatient.invoiceAddress.street }} {{ activePatient.invoiceAddress.houseNumber }}</span>
                                <span>{{ activePatient.invoiceAddress.zipCode }} {{ activePatient.invoiceAddress.city }}</span>
                            </div>
                        </div>
                        <div class="grid grid-cols-1 lg:grid-cols-3">
                            <span class="text-app-primary-10 text-sm">Telefon:</span>
                            <span class="col-span-2 font-normal text-sm lg:text-lg">{{ activePatient.phoneNumber }}</span>
                        </div>
                        <div class="grid grid-cols-1 lg:grid-cols-3">
                            <span class="text-app-primary-10 text-sm">Mobil:</span>
                            <span class="col-span-2 font-normal text-sm lg:text-lg">{{ activePatient.mobileNumber }}</span>
                        </div>
                        <div class="grid grid-cols-1 lg:grid-cols-3">
                            <span class="text-app-primary-10 text-sm">E-Mail:</span>
                            <span class="col-span-2 font-normal text-sm lg:text-lg break-all">{{ activePatient.email }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Rechte Karte: Neue Notiz -->
            <div class="col-span-12 lg:col-span-6">
                <div class="bg-white rounded-button shadow-sm border border-app-primary-10 p-6 h-full flex flex-col">
                    <div class="text-app-primary-20 font-semibold border-b border-app-primary-10/10 pb-2 mb-4">
                        Neue Notiz
                    </div>
                    <div class="flex-grow">
                        <textarea matInput
                                  [formControl]="noteFormControl"
                                  placeholder="Neue Notiz..."
                                  class="w-full bg-app-background-20 rounded border border-app-primary-10/10 p-3 text-sm focus:border-app-primary-10/20 outline-none transition-all min-h-[150px]"
                                  [rows]="6"></textarea>
                    </div>
                    <div class="flex flex-wrap items-center justify-between gap-4 mt-4">
                        <mat-checkbox class="text-primary" [formControl]="isImportantFromControl">
                            <span class="font-bold text-app-primary-10">Wichtige Notiz!</span>
                        </mat-checkbox>
                        <button class="btn primary-button" (click)="saveNote()">
                            <span>Notiz hinzufügen</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Unterer Teil: Tabs -->
        <div class="bg-white rounded-button shadow-sm border border-app-primary-10 w-full">
            <mat-tab-group class="app-tabs">
                <!-- Tab: Notizen -->
                <mat-tab label="Notizen">
                    <div class="p-6">
                        @if (activePatientFile && activePatientFile.notes.length > 0) {
                            <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                                @for (note of activePatientFile.notes; track note.id; let i = $index) {
                                    <div class="bg-app-background-20 rounded-lg border border-app-primary-10/10 p-4 relative group">
                                        <div class="flex justify-between items-start mb-2">
                                            <span class="text-xs font-semibold" [ngClass]="note.isImportant ? 'text-red-500' : 'text-app-primary-20'">
                                                Notiz #{{ i + 1 }} {{ note.isImportant ? ' (Wichtig!)' : '' }}
                                            </span>
                                            <span class="text-[10px] text-app-secondary-10">{{ note.updatedAt | date: 'dd.MM.yyyy' }}</span>
                                        </div>
                                        <textarea matInput
                                                  placeholder="Notiz"
                                                  #noteModel="ngModel"
                                                  [(ngModel)]="note.note"
                                                  rows="4"
                                                  class="w-full bg-white rounded border border-app-primary-10/5 p-2 text-sm focus:border-app-primary-10/20 outline-none transition-all min-h-[100px]"
                                                  [ngClass]="note.isImportant ? 'border-red-200' : ''"></textarea>

                                        <div class="flex items-center justify-between mt-3">
                                            <mat-checkbox [(ngModel)]="note.isImportant" #importantModel="ngModel">
                                                <span class="text-xs">Wichtig</span>
                                            </mat-checkbox>

                                            <div class="flex gap-2">
                                                @if (noteModel.dirty || importantModel.dirty) {
                                                    <button class="text-[10px] px-2 py-1 bg-app-primary-10 text-white rounded hover:bg-app-primary-20 transition-colors"
                                                            (click)="updateNote(note, noteModel, importantModel)">
                                                        Speichern
                                                    </button>
                                                }
                                                <button class="w-6 h-6 flex items-center justify-center rounded-full bg-red-100 text-red-600 hover:bg-red-500 hover:text-white transition-colors"
                                                        (click)="deleteNote(note.id!)">
                                                    <i class="fa-solid fa-times text-[10px]"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        } @else {
                            <div class="text-center py-10 text-app-secondary-10 italic">
                                Noch keine Notizen vorhanden.
                            </div>
                        }
                    </div>
                </mat-tab>

                <!-- Tab: Rezepte -->
                <mat-tab label="Rezepte">
                    <div class="p-6">
                        @if (patientRecipes && patientRecipes.length > 0) {
                            <div class="space-y-4">
                                @for (patRecipe of patientRecipes; track patRecipe.id; let i = $index) {
                                    <div class="bg-app-background-20 rounded-lg border border-app-primary-10/10 overflow-hidden shadow-sm">
                                        <button class="w-full p-4 flex justify-between items-center text-left hover:bg-app-primary-10/5 transition-colors"
                                                (click)="toggleRecipe(i)">
                                            <div class="flex flex-col">
                                                @if (patRecipe.isReadyForReview) {
                                                    <span class="font-semibold text-app-primary-20">Folgerezeptanfrage vom {{ patRecipe.issueDate | date: 'dd.MM.yyyy' }}</span>
                                                } @else {
                                                    <span class="font-semibold text-app-primary-20">Rezept vom {{ patRecipe.issueDate | date: 'dd.MM.yyyy' }}</span>
                                                }
                                                <span class="text-[10px] text-app-secondary-10">
                                                    ausgestellt von: {{ patRecipe.doctor.title ? patRecipe.doctor.title + ' ' : '' }}{{ patRecipe.doctor.firstName }} {{ patRecipe.doctor.lastName }}
                                                </span>
                                            </div>
                                            <div class="flex items-center gap-8">
                                                <div>
                                                    @if (patRecipe.state && patRecipe.state !== 'published') {
                                                        <span class="text-[16px] text-app-secondary-10">
                                                    Freigabe fehlt
                                                </span>
                                                    }
                                                </div>
                                                <i class="fa-solid transition-transform duration-200 fa-angle-down"
                                                   [ngClass]="openRecipeIndex === i ? ' rotate-180' : ''"></i>
                                            </div>
                                        </button>

                                        @if (openRecipeIndex === i) {
                                            <div class="p-4 border-t border-app-primary-10/5 bg-white/50">
                                                <div class="space-y-3 mb-4">
                                                    @for (position of patRecipe.positions; track position.articleNumber) {
                                                        <div class="flex justify-between items-center p-3 bg-white rounded border border-app-primary-10/5">
                                                            <div class="flex flex-col">
                                                                <span class="text-sm font-medium">{{ position.articleName }}</span>
                                                                <span class="text-[10px] text-app-secondary-10">Art.-Nr: {{ position.articleNumber }}</span>
                                                            </div>
                                                            <span class="text-xs font-semibold text-app-primary-10">
                                                                {{ position.quantity }} x {{ position.bindingSize }}
                                                            </span>
                                                        </div>
                                                    }
                                                </div>

                                                <div class="flex flex-wrap justify-end gap-3">
                                                    @if (patRecipe.state === 'published') {
                                                        <button class="btn secondary-button"
                                                                (click)="followRecipe(patRecipe, appointmentForRecipe)">
                                                            Folgerezept ausstellen
                                                        </button>
                                                    }
                                                    @if (patRecipe.state !== 'published' && patRecipe.doctor.id === doctor.id) {
                                                        <button class="btn secondary-button"
                                                                (click)="updateRecipe(patRecipe)">
                                                            Bearbeiten
                                                        </button>
                                                        <button class="btn primary-button"
                                                                (click)="openPrescriptionPreviewModal(patRecipe.id)">
                                                            Freigabe & Vorschau
                                                        </button>
                                                    } @else if (patRecipe.doctor.id === doctor.id) {
                                                        <button class="btn primary-button"
                                                                (click)="openPrescriptionPreviewModal(patRecipe.id, true)">
                                                            Download & Vorschau
                                                        </button>
                                                    }
                                                </div>
                                            </div>
                                        }
                                    </div>
                                }
                            </div>
                        } @else {
                            <div class="text-center py-10 text-app-secondary-10 italic">
                                Noch keine Rezepte vorhanden.
                            </div>
                        }
                    </div>
                </mat-tab>

                <!-- Tab: Ausweisdokumente -->
                <mat-tab label="Ausweisdokumente">
                    <div class="p-6">
                        @if (isLoadingIdFiles) {
                            <div class="flex flex-col items-center justify-center py-12 gap-4">
                                <i class="fa-solid fa-circle-notch fa-spin text-4xl text-app-primary-10"></i>
                                <p class="text-app-secondary-10 animate-pulse">Lade Ausweisdokumente...</p>
                            </div>
                        } @else if (showUploadFields || !idFiles || idFiles.length === 0) {
                            <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
                                <div class="flex flex-col gap-4">
                                    <label class="text-app-primary-20 font-medium">Vorderseite des Personalausweises</label>
                                    @if (idDocuments.front.fileData == '') {
                                        <app-file-upload [useBase64Upload]="true" [base64WithInfos]="true" (fileSelected)="onFileSelectedFront($event)" [allowedMimeTypes]="['image/jpeg', 'image/png']" class="bg-app-background-20 rounded-lg p-6 border-2 border-dashed border-app-primary-10/10"></app-file-upload>
                                    } @else {
                                        <div class="relative group aspect-video overflow-hidden rounded-lg shadow-md border border-gray-200">
                                            <button class="absolute top-2 right-2 bg-red-500 hover:bg-red-600 text-white w-10 h-10 flex items-center justify-center rounded-full shadow-lg z-10 transition-all transform hover:scale-110" (click)="removeFile('front')">
                                                <i class="fa-solid fa-trash-can text-sm"></i>
                                            </button>
                                            <img [src]="'data:image/jpeg;base64,' + idDocuments.front.fileData" alt="Vorderseite" class="w-full h-full object-cover">
                                        </div>
                                    }
                                </div>
                                <div class="flex flex-col gap-4">
                                    <label class="text-app-primary-20 font-medium">Rückseite des Personalausweises</label>
                                    @if (idDocuments.back.fileData == '') {
                                        <app-file-upload [useBase64Upload]="true" [base64WithInfos]="true" (fileSelected)="onFileSelectedBack($event)" [allowedMimeTypes]="['image/jpeg', 'image/png']" class="bg-app-background-20 rounded-lg p-6 border-2 border-dashed border-app-primary-10/10"></app-file-upload>
                                    } @else {
                                        <div class="relative group aspect-video overflow-hidden rounded-lg shadow-md border border-gray-200">
                                            <button class="absolute top-2 right-2 bg-red-500 hover:bg-red-600 text-white w-10 h-10 flex items-center justify-center rounded-full shadow-lg z-10 transition-all transform hover:scale-110" (click)="removeFile('back')">
                                                <i class="fa-solid fa-trash-can text-sm"></i>
                                            </button>
                                            <img [src]="'data:image/jpeg;base64,' + idDocuments.back.fileData" alt="Rückseite" class="w-full h-full object-cover">
                                        </div>
                                    }
                                </div>
                            </div>
                        } @else {
                            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                                @for (file of idFiles; track file.id) {
                                    <div class="flex flex-col gap-4">
                                        <label class="text-app-primary-20 font-medium text-xs">
                                            @if (file.fileName.includes('back')) {
                                                <span>Rückseite des Personalausweises</span>
                                            } @else {
                                                <span>Vorderseite des Personalausweises</span>
                                            }
                                        </label>
                                        <div class="relative group aspect-video overflow-hidden rounded-lg shadow-md border border-app-primary-10/10 bg-white">
                                            <div class="absolute top-2 right-2 flex gap-2 z-10">
                                                <button class="bg-app-primary-10 hover:bg-app-primary-20 text-white w-8 h-8 flex items-center justify-center rounded-full shadow-lg transition-all transform hover:scale-110" (click)="triggerDownload(file)" title="Download">
                                                    <i class="fa-solid fa-download text-xs"></i>
                                                </button>
                                            </div>
                                            @if (file.base46) {
                                                <img [src]="'data:image/png;base64,' + file.base46" alt="Vorschau" class="w-full h-full object-cover">
                                            } @else {
                                                <div class="w-full h-full flex items-center justify-center bg-gray-100">
                                                    <i class="fa-solid fa-image text-2xl text-gray-300"></i>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                }
                            </div>
                        }
                    </div>
                </mat-tab>

                <!-- Tab: Dokumente -->
                <mat-tab label="Dokumente">
                    <div class="p-6">
                        <app-patient-file-handling [patient]="activePatient" [isDoctor]="true" [excludeType]="'id-documents'"></app-patient-file-handling>
                    </div>
                </mat-tab>
                <mat-tab label="Stammapotheke">
                    <div class="p-6">
                        <div [formGroup]="customPharmacyForm"
                             class="grid grid-cols-1 md:grid-cols-2 gap-4 p-4 bg-gray-50 rounded-xl border border-gray-100">
                            <div class="md:col-span-2">
                                <label class="text-[10px] font-bold text-app-primary-10 uppercase">Name der Apotheke</label>
                                <input matInput formControlName="name" placeholder="Apotheke am Markt"
                                       class="w-full bg-white rounded-lg p-2 text-sm mt-1">
                            </div>
                            <div>
                                <label class="text-[10px] font-bold text-app-primary-10 uppercase">Straße</label>
                                <input matInput formControlName="street" placeholder="Marktstraße"
                                       class="w-full bg-white rounded-lg p-2 text-sm mt-1">
                            </div>
                            <div>
                                <label class="text-[10px] font-bold text-app-primary-10 uppercase">Hausnummer</label>
                                <input matInput formControlName="houseNumber" placeholder="1"
                                       class="w-full bg-white rounded-lg p-2 text-sm mt-1">
                            </div>
                            <div>
                                <label class="text-[10px] font-bold text-app-primary-10 uppercase">PLZ</label>
                                <input matInput formControlName="zipCode" placeholder="11111"
                                       class="w-full bg-white rounded-lg p-2 text-sm mt-1">
                            </div>
                            <div>
                                <label class="text-[10px] font-bold text-app-primary-10 uppercase">Stadt</label>
                                <input matInput formControlName="city" placeholder="Marktstadt"
                                       class="w-full bg-white rounded-lg p-2 text-sm mt-1">
                            </div>
                            <div>
                                <label class="text-[10px] font-bold text-app-primary-10 uppercase">Telefonnummer</label>
                                <input matInput formControlName="phoneNumber" placeholder="+49 123 4567890"
                                       class="w-full bg-white rounded-lg p-2 text-sm mt-1">
                            </div>
                            <div>
                                <label class="text-[10px] font-bold text-app-primary-10 uppercase">E-Mail Adresse</label>
                                <input matInput formControlName="email" placeholder="email@email.de"
                                       class="w-full bg-white rounded-lg p-2 text-sm mt-1">
                            </div>
                        </div>
                        <div class="flex justify-end mt-8">
                            <button class="btn primary-button" (click)="savePharmacy()">Speichern</button>
                        </div>

                    </div>
                </mat-tab>
            </mat-tab-group>
        </div>
    </div>
}
